"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassyStudentView = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const UI_1 = require("@frontend/util/UI");
const AbstractStudentView_1 = require("@frontend/views/AbstractStudentView");
class ClassyStudentView extends AbstractStudentView_1.AbstractStudentView {
    constructor(remoteUrl) {
        super();
        Log_1.default.info("CustomStudentView::<init>");
        this.remote = remoteUrl;
    }
    renderPage(opts) {
        Log_1.default.info("CustomStudentView::renderPage() - start; options: " + opts);
        const start = Date.now();
        UI_1.UI.showModal("Fetching data.");
        super
            .render()
            .then(function () {
            Log_1.default.info("CustomStudentView::renderPage(..) - prep & render took: " + UI_1.UI.took(start));
            UI_1.UI.hideModal();
        })
            .catch(function (err) {
            Log_1.default.error("CustomStudentView::renderPage() - ERROR: " + err);
            UI_1.UI.hideModal();
        });
    }
}
exports.ClassyStudentView = ClassyStudentView;
